import React from "react";
import PropTypes from "prop-types";
import { filterNull, getFileProps } from "cxa-utils";
import { FormattedCustomDate } from "components/common/FormattedComponents";
import { FormattedMessage } from "react-intl";
import messagesDescription from "components/messagesDescription";
import { isExist } from "cxa-utils";
import Attachment from "./Attachment";
import moment from "moment";

const renderFiles = value => {
  const files = [].concat(value).filter(filterNull);

  return files.length > 0
    ? files.map(file => {
        const props = getFileProps(file);

        return (
          <div key={props.name} className="cxa-grid__item cxa-grid__item--four">
            <Attachment className="u-margin-top" {...props} />
          </div>
        );
      })
    : "-";
};

renderFiles.propTypes = {
  name: PropTypes.string,
};

const filterMessage = ({ html, text }) => {
  let message = text;

  if (isExist(html)) {
    message = html.replace(/a:(.*?|\n)*?{(.*?|\n)*?}/g, "");
  }

  return {
    __html: message,
  };
};

const MessageContentCard = props => {
  const {
    to,
    from,
    text,
    html,
    createOn,
    subject,
    // pkMessage,
    digitalContentAzureDtos,
    hasAttachment,
  } = props;

  const { fromText, toText, messageSendBtn } = messagesDescription.inAppMessages;
  const timeFormat = moment.localeData().longDateFormat("ll") + " H:mm A";
  return (
    <div>
      <h3>{subject}</h3>

      <div>
        <strong>
          <FormattedMessage {...fromText} />
        </strong>
        {` ${from}`}
      </div>

      <div>
        <strong>
          <FormattedMessage {...toText} />
        </strong>
        {` ${to}`}
      </div>

      <div>
        <strong>
          <FormattedMessage {...messageSendBtn} />:{" "}
        </strong>

        <FormattedCustomDate customFormat={timeFormat} value={createOn} />
      </div>

      {hasAttachment && (
        <div className="cxa-grid__wrapper">{renderFiles(digitalContentAzureDtos)}</div>
      )}

      <section className="message-body" dangerouslySetInnerHTML={filterMessage({ html, text })} />
    </div>
  );
};

MessageContentCard.propTypes = {
  to: PropTypes.string,
  from: PropTypes.string,
  createOn: PropTypes.string,
  text: PropTypes.string,
  html: PropTypes.string,
  subject: PropTypes.string,
  pkMessage: PropTypes.string,
  digitalContentAzureDtos: PropTypes.array,
  hasAttachment: PropTypes.bool,
};

MessageContentCard.defaultProps = {
  html: "",
};

export default MessageContentCard;



// WEBPACK FOOTER //
// ./components/inAppMessages/MessageContentCard.js